import { useLazyQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import { AppPagePaths } from "App/routes/paths";
import { SettingsPaths } from "Pages/settings/paths";

import { getAgents, GetAgentsResponse } from "./queries";
import { SpotlightUsersItem } from "./SpotlightUsersItem";

export const useGetSearchUsers = (onCallback: () => void) => {
    const navigate = useNavigate();
    const [getUsers, { loading }] = useLazyQuery<GetAgentsResponse>(getAgents);

    const handleGetUsers = async (searchValue: string) => {
        const users = await getUsers({
            variables: {
                queryParams: { filterBy: [{ key: "name", value: searchValue, operator: "contains" }] },
            },
        });
        const usersData = users.data?.findAllAgents.items.map((item) => {
            const route = `${AppPagePaths.settings}/${SettingsPaths.userManagementEditUser.replace(":userId", item.id)}`;

            return {
                label: (
                    <SpotlightUsersItem
                        name={item.name}
                        description={item.email}
                        searchValue={searchValue}
                        route={route}
                        onCallback={() => {
                            onCallback();
                            navigate(route);
                        }}
                    />
                ),
                value: item.id,
            };
        });

        if (!usersData?.length || !searchValue) {
            return [];
        }

        return [
            {
                label: "Users",
                options: usersData,
            },
        ];
    };

    return {
        getUsers: handleGetUsers,
        loading,
    };
};
